import { Flex, LottieAnimation } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

const LOADING_ANIMATION_SIZE = 48

/**
 * The drawer waits for the invoice and the form column waits for the organization; both show this.
 * The invoice resolves first, so the two never appear at once.
 */
export const ImportedInvoiceDrawerLoader = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <Flex alignItems="center" flexGrow={1} justifyContent="center">
      {/* `FlexProps` does not accept `role`, so the status sits on the element it centres. */}
      <div aria-label={t('loading')} role="status">
        <LottieAnimation height={LOADING_ANIMATION_SIZE} name="processing" width={LOADING_ANIMATION_SIZE} />
      </div>
    </Flex>
  )
}
